export default "__VITE_ASSET__CtM0mtqP__"